import { FC } from "react";
import css from './index.module.css';
import * as Types from '../../types';
import { useNavigate } from "react-router-dom";

interface Container {
  uuid: string;
  name: string;
  domain: string;
  status: number;
  isAdmin?: boolean;
  payment?: any;
}

const ContainerMini:FC<Container> = ({ uuid, name, domain, status, isAdmin = false, payment }) => {
  const navigate = useNavigate();

  const calculateDaysLeft = (updatedAt: string) => {
    const normalized = /(?:Z|[+-]\d{2}:?\d{2})$/.test(updatedAt) ? updatedAt : updatedAt.replace(' ', 'T') + 'Z';
    const diffDays = Math.ceil((new Date(normalized).getTime() - Date.now()) / 86400000);
    return diffDays;
  };

  const daysLeft = payment?.updatedAt ? calculateDaysLeft(payment.updatedAt) : NaN;

  return (
    <div className={css.container} onClick={() => navigate(isAdmin === false ? `/container/${uuid}` : `/admin/container/${uuid}`)}>
        <div className={css.mainInfo}>
          <b>{name}</b>
          <a>{domain}</a>
        </div>
        {!Number.isFinite(daysLeft) ? <div className={css.status}><a>Статус оплаты недоступен</a></div> : daysLeft >= 1 ?
        <div className={css.status}>
          <a>{status === 5 ? `Активен еще ${daysLeft} ${daysLeft === 1 ? 'день' : (daysLeft > 1 && daysLeft < 5) ? 'дня' : 'дней'}` : 'Настраивается'}</a>
        </div>
        :
        <div className={css.status} style={{ background: "#ed6666", color: "#fff" }}>
          <a>Оплатите контейнер</a>
        </div>
        }
    </div>
  );
};

export default ContainerMini;